/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaStepAlt/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2CheckCircleHollow from 'DesignSystem/Svgs/Tysiav2CheckCircleHollow/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaStepAlt({
  children,
  viewPath = "/DesignSystem/TysiaStepAlt",
  selected,
  size,
  step,
  width,
  weight,
  text,
  complete,
  isRequired
  
}) {
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsNeutral800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.800'
        })
let dtColorsRed600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.600'
        })
  return (<React.Fragment
>
<div
  data-testid="TysiaStepAlt.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-Z1dXQa2': selected ? dtColorsNeutral100 : "transparent"}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="TysiaStepAlt.Vertical"
  data-view-path={viewPath}
 style={{'--mr-2-Z1dXQa2': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-3-Z1dXQa2': dtColorsNeutral200,'--bc-1-Z1dXQa2': dtColorsNeutral200}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size={size}
 color={dtColorsNeutral800}
 display="flex"
 text={step}
/>
</div>
<div
  data-testid="TysiaStepAlt.Horizontal:1"
  data-view-path={viewPath}
 style={{'--w-4-Z1dXQa2': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight={selected ? "medium" : weight}
 size={size}
 text={text}
/>
<fromFlow.When is={complete}>
<div
  data-testid="TysiaStepAlt.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<Tysiav2CheckCircleHollow
  viewPath={`${viewPath}/Tysiav2CheckCircleHollow`}
/>
</div>
</fromFlow.When>
</div>
<fromFlow.When is={isRequired}>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="*"
 marginLeft="2px"
 color={dtColorsRed600}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}